import { useState, FC } from "react";
import { Button } from "react-bootstrap";
import { CartellaModal } from "components/cartellaModal";
import { AddFile } from "./add-file";
import { useAppDispatch } from "redux/store";
import { useBucketContext } from "context/bucket";
import { showErrorModal } from "redux/slices";

export const CartellaButtons: FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { apiHandler, refreshContents } = useBucketContext();
  const dispatch = useAppDispatch();

  const handleRefresh = async () => {
    const result = await refreshContents();
    !result &&
      dispatch(
        showErrorModal({
          text: "Qualcosa è andato storto, esegui nuovamente l'operazione",
        })
      );
  };
  return (
    <>
      <div className="d-inline-flex text-white gap-2">
        <Button
          variant="secondary text-white text-nowrap fs-sm-12"
          onClick={() => apiHandler(handleRefresh)}
        >
          <i className="bi bi-arrow-clockwise"></i>
        </Button>
        <AddFile />
        <Button
          onClick={() => setShowModal(true)}
          variant="secondary text-white fw-light text-nowrap"
          className="d-flex align-items-center gap-2 fs-sm-12"
        >
          <i className="bi bi-folder2 mx-1" />
          <span>CREA CARTELLA</span>
        </Button>
      </div>
      <CartellaModal
        show={showModal}
        closeModal={() => setShowModal(false)}
        title={"Crea Cartella"}
      />
    </>
  );
};
